export default "__VITE_ASSET__BuAlX4Tl__"